import { api } from "./api";

export const taxesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTaxes: builder.query({
      query: () => "api/Fin/Taxs",
      providesTags: ["taxes"],
    }),
    addTax: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Taxs",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["taxes"],
    }),
    editTax: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/Taxs",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["taxes"],
    }),
    deleteTax: builder.mutation({
      query: (taxId) => ({
        url: `api/Fin/Taxs?TaxID=${taxId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["taxes"],
    }),
  }),
});

export const {
  useGetTaxesQuery,
  useAddTaxMutation,
  useEditTaxMutation,
  useDeleteTaxMutation,
} = taxesApi;
